
import React from 'react';
import {Overlay} from "../../components/modal";
import {TextLoading} from "../../funcs/utils";
import { sprintf } from "sprintf-js";
import {DIALOG_STYLE, ERRORS, render_header, render_amt_input,
  parse_amt, mult_of_1000} from "./common";


const render_button = (component, id, label, bg_color, cusip, available_cash, address_state) => {
  const style = {
    background: sprintf("rgba(%d, %d, %d", bg_color.r, bg_color.g, bg_color.b),
    width: "10rem",
    padding: "0.5rem 0"
  }

  const on_click = () => {
    if (component.state.purchase_amt === "") {
      if (id === "sign_in") {
        component.props.navigatePath("/login");
        return;
      } else if (id === "create_account") {
        component.props.navigatePath("/new_account");
        return;
      }
    }
    const amt = parse_amt(component.state.purchase_amt);
    if (amt < 1000.) {
      component.setState({
        dialog_error: ERRORS.TOO_SMALL,
      })
    } else if (!mult_of_1000(amt)) {
      component.setState({
        dialog_error: ERRORS.MULTIPLE_1000,
      });
    } else if (amt > available_cash) {
      component.setState({
        dialog_error: ERRORS.NOT_ENOUGH_CASH,
      })
    } else {
      component.onPurchaseDialogClick(id, cusip);
    }
  }
  return (
    <button
      style={style}
      onClick={ on_click }>
      { label }
    </button>
  )
}

const render_footer_logged_out = (component, cusip) => {

  const client = component.props.client;
  const button_bg = client.color.sign_on_button;
  return (
    <div style={{ display: "flex", marginTop: "2rem", alignItems: "center"}}>
      <div>
        { render_button(component, "sign_in", "Sign In", button_bg, cusip) }
      </div>
      <div style={{flex: "1"}} align={"center"}>
        Are you new?
      </div>
      <div>
        { render_button(component, "create_account", "Create Account", button_bg, cusip) }
      </div>
    </div>
  );
}

const render_footer_logged_in = (
  component, cusip, is_purchasing, available_cash, address_state) => {
  const client = component.props.client;
  const button_bg = client.color.sign_on_button;
  return (
    <div style={{ display: "flex", marginTop: "2rem", justifyContent: "center"}}>
      <div>
        { render_button(component, "purchase",
          (<TextLoading label={"Purchase"} loading={is_purchasing}/>),
          button_bg, cusip, available_cash, address_state) }
      </div>
    </div>
  )
}

const PurchaseModal = props => {

  const item = props.item;
  const component = props.component;
  const logged_in = props.logged_in;

  return (
    <Overlay>
      <div style={DIALOG_STYLE}>
        { render_header(item, component) }
        <div style={{height: "2rem"}}/>
        { render_amt_input(component) }
        { !logged_in && render_footer_logged_out(component, item.CUSIP) }
        { logged_in && render_footer_logged_in(
          component, item.CUSIP, props.is_purchasing, props.available_cash,
          props.address_state) }
      </div>
    </Overlay>
  )
}

export { PurchaseModal };
